import { render } from "./RegistroPedidos.vue?vue&type=template&id=328c0be6"
import script from "./RegistroPedidos.vue?vue&type=script&lang=js"
export * from "./RegistroPedidos.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__